import React, { useState } from 'react';
import { T } from '@/components/T';
import i18n from 'i18next';
import { useGet } from '@/query/fetchHooks';
import { Panel, IconButton } from '@teo/components';
import { ChevronUp, ChevronDown } from '@teo/components/icons';
import { FaqList } from './FaqList';

const FaqTopic = ({ topic, limit }) => {
  const [faqs, setFaqs] = useState([]);
  const [collapsed, setCollapsed] = useState(true);

  useGet(`/faqs`, {
    enabled: !collapsed,
    lang: i18n.language,
    sort: 'priority',
    topic,
    limit,
    onSuccess: (results) => {
      setFaqs(results.data);
    },
  });

  return (
    <Panel className="flex flex-col break-words">
      <h3
        className="flex cursor-pointer flex-row items-center justify-between p-4"
        onClick={() => setCollapsed((c) => !c)}
      >
        <T>{`pages.faq.topic.${topic}`}</T>

        <IconButton
          Icon={!collapsed ? ChevronUp : ChevronDown}
          variant="ghost"
        />
      </h3>

      {!collapsed && <FaqList faqs={faqs} />}
    </Panel>
  );
};

export { FaqTopic };
